import { Dispatch } from 'redux';

import { clearData, toggleClose, toggleOpen } from './actions';

/**
 * @deprecated
 * @param dispatch
 */
const modalActionsCreator = (dispatch: Dispatch) => ({
  dispatchToggleOpen: (name = '', payload?: any) => dispatch(toggleOpen(name, payload)),
  dispatchToggleClose: (name = '') => dispatch(toggleClose(name)),
  dispatchClearData: (name = '') => dispatch(clearData(name)),
});

export default modalActionsCreator;
